export class EnumModel {
  value: number;
  name: string;
  displayName: string;
  isSelected: boolean;
  isDisabled: boolean;
}
